module.exports = __webpack_public_path__ + "static/media/pizza2.0de3fbde.jpg";